import { useState, useRef } from "react";
import { motion } from "framer-motion";
import logoVideo from "../../asset/Home/AI_LOGO.mp4";
import voiceWave from "../../asset/Home//AIVoiceWave.svg";
import voiceCircle from "../../asset/Home//AIVoiceCircles.svg";
import micWhite from "../../asset/Home//micWhite.svg";
import demoCardImage from "../../asset/Home//demoCardImage.svg";
import micOrange from "../../asset/Home//micOrange.svg";
import { useNavigate } from "react-router-dom";
import englishAudio from "../../asset/Home/en_02.wav";
import hindiAudio from "../../asset/Home/hi_02.wav";
import playWhite from "../../asset/Home/play white.svg";
import pauseGray from "../../asset/Home/pause gray.svg";

export default function OurAgents() {
  const [isTalking, setIsTalking] = useState(false);
const [activeLanguage, setActiveLanguage] = useState("");

const audioRef = useRef(null);
  const navigate = useNavigate();
const playAudio = (lang) => {
  // If same language is already playing -> Stop
  if (
    activeLanguage === lang &&
    audioRef.current &&
    !audioRef.current.paused
  ) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;

    setIsTalking(false);
    setActiveLanguage("");

    return;
  }

  // Stop previous audio
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  }

  const src = lang === "english" ? englishAudio : hindiAudio;

  const audio = new Audio(src);

  audioRef.current = audio;

  setActiveLanguage(lang);
  setIsTalking(true);

  audio.onended = () => {
    setIsTalking(false);
    setActiveLanguage("");
  };

  audio.play();
};
  return (
    <section
      className="py-16 lg:py-34 px-4 lg:px-20 bg-white"
      style={{ zoom: "0.8" }}
    >
      <div className="max-w-[1380px] mx-auto">
        <div className="text-center">
          <span className="inline-flex px-4 py-1 rounded-md bg-[#FFE9E4] font-prompt text-[#EB604A] font-semibold text-[18px]">
            Our Products
          </span>
          <h2 className="mt-5 text-[#45453D] font-bold font-prompt text-3xl md:text-5xl">
           Built to Sound Like Your Top Performers

          </h2>
          <p className="mt-5 max-w-3xl mx-auto text-[18px] text-[#666] font-jakarta leading-7">
Sales AI guides your reps live. Voice AI answers for you 24/7. One standard: natural, capable, always on.          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10 mt-14">
   <motion.div
  initial="rest"
  whileHover="hover"
  whileTap={{ scale: 0.98 }}
  onClick={() => navigate("/agents/sales")}
  className="rounded-xl border border-[#0C020029] bg-white overflow-hidden shadow-sm cursor-pointer"
>
            <div className="p-4">
<div className="relative h-[260px] lg:h-[320px] rounded-xl overflow-hidden border border-[#0C020029]">                {/* Background circles */}
                <div className="absolute -top-10 left-16 w-52 h-52 rounded-full bg-[#FFD6CF]/40"></div>
                <div className="absolute -bottom-16 right-0 w-60 h-40 rounded-full bg-[#FFE7AE]/40"></div>
<motion.div
  variants={{
    rest: {
      scale: 1,
    },
    hover: {
      scale: 1.40,
    },
  }}
  transition={{
    type: "spring",
    stiffness: 350,
    damping: 18,
  }}
  className="
    absolute
    lg:h-[60%]
    z-0
    left-[-10px]
          lg:left-[-20px]
          md:left-[-20px]
          lg:top-[-10px]
    will-change-transform
  "
>
  <img
    src={demoCardImage}
    alt="Demo Card"
    className="
      h-[135%]
      md:h-[130%]
      lg:h-[190%]
      lg:left-[80px]
      w-[145%]
      md:w-auto

      max-w-none
      object-contain
      pointer-events-none
      block
    "
  />
</motion.div>
            </div>
              </div>
        
            <div className="px-6 pb-6">
              <h3 className="font-bold lg:text-2xl text-lg font-prompt text-[#0C0200]">
                Sales AI
              </h3>
              <p className="mt-3 text-[#0C0200] text-[14px] lg:text-[16px] font-jakarta leading-6 md:leading-7 lg:leading-8">
                Your AI sales expert for every meeting—capturing conversations,
                guiding reps and delivering insights.
              </p>
            </div>
          </motion.div>
          <motion.div
            whileHover={{ y: -6 }}
            className="rounded-2xl border border-[#0C020029] bg-white overflow-hidden shadow-sm"
          >
           
            <div className="relative p-4">
<div className="relative h-[260px] lg:h-[320px] rounded-xl border border-[#0C020029] overflow-hidden bg-gradient-to-r from-[#FFF5F3] via-[#FFFDFB] to-[#FFF8DD]">                {/* Wave */}

                <motion.img
                  src={voiceWave}
                  alt=""
                  className="absolute -left-[15px] top-[115px] md:top-[105px] lg:top-[130px] -translate-y-1/2  lg:w-[300px] lg:h-[150px] w-[240px] h-[150px] object-contain"
                />
                <motion.img
                  src={voiceWave}
                  alt=""
                  className="absolute -right-[70px] md:-right-[100px] lg:-right-[40px] top-[115px] md:top-[105px] lg:top-[130px] -translate-y-1/2 w-[270px] h-[150px] lg:w-[330px] lg:h-[150px] object-contain scale-x-[-1]"
                />

                <motion.img
                  src={voiceCircle}
                  className="absolute inset-0 left-[100px] md:left-[150px] lg:left-[220px] mt-10 lg:mt-8  w-[140px] h-[140px] lg:w-[200px] lg:h-[200px] object-contain"
                  animate={
                    isTalking
                      ? {
                          scale: [
                            1, 1.03, 1.06, 1.09, 1.12, 1.09, 1.06, 1.03, 1,
                          ],
                          opacity: [0.95, 1, 0.98, 1, 0.96],
                        }
                      : {
                          scale: 1,
                          opacity: 1,
                        }
                  }
                  transition={
                    isTalking
                      ? {
                          duration: 2,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }
                      : {
                          duration: 0,
                        }
                  }
                />
                {/* Center */}

                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative md:ml-6 ml-2 lg:ml-2 mb-[36px] md:mb-[38px] lg:mb-[55px]  w-[100px] h-[100px] lg:w-[150px] lg:h-[150px]">
                    {/* Logo */}

                    <div className="absolute inset-0 flex items-center justify-center z-20">
                      <div className="lg:w-24 lg:h-24 w-16 h-16 rounded-full overflow-hidden">
                        <video
                          autoPlay
                          muted
                          loop
                          playsInline
                          className="w-full h-full object-cover scale-[2.15]"
                        >
                          <source src={logoVideo} type="video/mp4" />
                        </video>
                      </div>
                    </div>

                    {/* Mic */}

                    <button
                      onClick={() => setIsTalking(!isTalking)}
                      className="absolute inset-0 flex  items-center justify-center z-30"
                    >
                      <img
                        src={isTalking ? micOrange : micWhite}
                        className="lg:w-8 w-5"
                        alt=""
                      />
                    </button>
                  </div>
                </div>


                <div className="absolute text-[14px] md:text-[14px] lg:text-[18px] bottom-5 font-jakarta left-8  right-8 md:left-10  md:right-10 lg:left-12 lg:right-12 z-40 flex gap-3">
  <button
  onClick={() => playAudio("english")}
  className={`flex-1 h-8 md:h-9 lg:h-11 rounded-lg border transition-all font-medium shadow-md
    flex items-center justify-center gap-2
    ${
      activeLanguage === "english"
        ? "bg-[#EB604A] text-white border-[#EB604A]"
        : "bg-white text-[#4A4A4A] border-[#F1C9C2]"
    }`}
>
  <img
    src={
      activeLanguage === "english"
        ? playWhite      // Orange button → White Play
        : pauseGray      // White button → Gray Pause
    }
    className="w-5 h-5"
    alt=""
  />

  English
</button>

 <button
  onClick={() => playAudio("hindi")}
  className={`flex-1 h-8 md:h-9 lg:h-11 rounded-lg border transition-all font-medium shadow-md
    flex items-center justify-center gap-2
    ${
      activeLanguage === "hindi"
        ? "bg-[#EB604A] text-white border-[#EB604A]"
        : "bg-white text-[#4A4A4A] border-[#F1C9C2]"
    }`}
>
  <img
    src={
      activeLanguage === "hindi"
        ? playWhite
        : pauseGray
    }
    className="w-5 h-5"
    alt=""
  />

  Hindi
</button>
</div>
              </div>
            </div>
            <div className="px-6 pb-6">
              <h3 className="font-bold lg:text-2xl text-lg font-prompt text-[#0C0200]">
                Voice AI
              </h3>
              <p className="mt-3 text-[#0C0200] text-[14px] lg:text-[16px] font-jakarta leading-6 md:leading-7 lg:leading-8">
                Deploy AI voice agents that sound natural, understand context, and handle conversations across sales, support, HR, and more—24/7 in 50+ languages.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
